import React from 'react'
import RetailerCard from '../RetailerCard/RetailerCard'

import styles from './RetailerList.module.scss'

import { RetailerFragment } from '@lib/umbraco/generated/types.generated'
import { PropsWithChildren } from 'react'

interface Props {
  visibleRetailers: RetailerFragment[]
  onRetailerClick?: (retailer: RetailerFragment) => void
  retailerListHeadline: string
  selectedRetailer: RetailerFragment | undefined
  directionsText: string

  centerPosition: google.maps.LatLng | undefined
}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLDivElement>, keyof Props>

export type RetailerListProps = Props & NativeAttrs

const RetailerList = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<RetailerListProps>
>(
  (
    {
      visibleRetailers,
      onRetailerClick,
      retailerListHeadline,
      selectedRetailer,
      directionsText,
      centerPosition,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={styles.container} {...props} ref={ref}>
        <ol className={styles.retailerslist}>
          {visibleRetailers &&
            visibleRetailers
              .sort((a, b) => {
                if (selectedRetailer?.odooUUID == b.odooUUID) {
                  return 1
                }
                const distanceA =
                  google.maps.geometry.spherical.computeDistanceBetween(
                    new google.maps.LatLng({
                      lat: parseFloat(a.geoLatitude),
                      lng: parseFloat(a.geoLongitude),
                    }),
                    centerPosition!,
                  )
                const distanceB =
                  google.maps.geometry.spherical.computeDistanceBetween(
                    new google.maps.LatLng({
                      lat: parseFloat(a.geoLatitude),
                      lng: parseFloat(a.geoLongitude),
                    }),
                    centerPosition!,
                  )
                return distanceA > distanceB ? 1 : -1
              })
              .map((retailer) => (
                <RetailerCard
                  key={retailer.odooUUID}
                  retailer={retailer}
                  directionsText={directionsText}
                  onRetailerClick={onRetailerClick}
                  selectedRetailer={selectedRetailer}
                  {...props}
                />
              ))}
        </ol>
      </div>
    )
  },
)

RetailerList.displayName = 'RetailerList'
export default RetailerList
